export default "__VITE_ASSET__iqzbAgX5__"